export default {
  name: 'marking--docLink',
};